module.exports = __webpack_public_path__ + "img/congo-dr-logo-icon.9b06b300.png";